import React, { Component } from 'react';
// utils
import {Translations, convertStringToArray} from '../../../../utils';
// children
import CaseOwner from './CaseOwner';
import Status from './Status';
import SimpleDropdown from '../../../common/SimpleDropdown';
// style
import './Filter.css';

export default class Filter extends Component{
  constructor(props) {
    super(props);
    this.state = {
      inputStr : ''
    }
  }

  getStatusOnchange = (str) => {
    this.setState({
      inputStr : str
    });
    this.props.getStatusOnchange(str)
  }

  getStatusOnUserchange = (str) => {
    this.setState({
      inputStr : str
    });
    this.props.getStatusOnUserchange(str)
  }

  forceUpdateCustom =() => {
    let customE= {
      target :{
        value :'all'
      }
    }
    this.setState({
      inputStr:''
    });
    this.refs.status._clearStatus();
    this.refs.caseowner._clearStatus();
    this.props.getStatusOnchange('All Events');
    this.filterByEntity(customE);
    //this.forceUpdate();
    this.props.resetAllData()
  }

  filterByEntity = (event) =>{
    this.setState({entityFilterSelection: event.target.value});
    this.props.filterByEntity(event.target.value);
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render(){

    return(
      <div className="gdoc-caselist-filter">
        <ul>
           <li>
            {
              this.props.caseOwner.length > 0
              ? <CaseOwner
                  ref="caseowner"
                  caseOwner={this.props.caseOwner}
                  value={this.state.inputStr}
                  getStatusOnchange={(str) => this.getStatusOnUserchange(str)}
                  heading={this.translateWord(this.props.pageJson.table_caseHistoryTable.filterDropdownLabels)[0]}
                  data={this.props.pageJson.table_caseHistoryTable}
                  lang={this.props.lang}
                />
              : ''
            }
            {
              this.props.eventStatus.length > 0
              ? <Status
                  ref="status"
                  eventStatus={this.props.eventStatus}
                  value={this.state.inputStr}
                  getStatusOnchange={(str) => this.getStatusOnchange(str)}
                  data={this.props.pageJson.table_caseHistoryTable}
                  lang={this.props.lang}
                />
              :""
            }
           <div className="gdoc-caselist-filter-dropcontainer">
            {
              this.props.eventStatus.length > 0
              ? Object.keys(this.props.cases).length > 1
                ? (<SimpleDropdown
                    options={this.props.entitiesList}
                    showPleaseSelectOption={false}
                    value={this.state.entityFilterSelection}
                    _onChange={this.filterByEntity}
                    optionTextSelector="entityName"
                    valueSelector="caseId"
                    />)
                  : ''
                : ''
             }
            </div>
            <span
              onClick={()=>this.forceUpdateCustom()}
              role="link"
              tabIndex="0"
            >
              {Translations(this.props.pageJson.table_caseHistoryTable.clearFilterText,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            </span>
          </li>
        </ul>
      </div>)
    }
}

Filter.defaultProps = {
eventStatus : [],
caseOwner :[],
entitiesList : []
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/CaseHistory/Grid/Filter.js